<template>
  <!-- 此处为入口 公共部分可以放到这里 -->
  <div id="app">
    <gc-public-header></gc-public-header>
    <!-- 缓存页面 -->
    <keep-alive :max="1">
      <router-view v-if="$route.meta.keep" class="common-view" :style="{'height': height + 'px'}"/>
    </keep-alive>
    <router-view v-if="!$route.meta.keep" class="common-view" :style="{'height': height + 'px'}"/>
  </div>
</template>

<script>
import INTERFACE from './interface'
import {clickBody} from 'gclife-common-front/lib/verifyTable'

export default {
  name: 'app',
  computed: {
    height() {
      return document.documentElement.clientHeight - 46
    }
  },
  mounted() {
    clickBody()
  },
  created() {
    // 获取字典
    INTERFACE.dic().then(res => {
      // vux全局存值
      this.$store.dispatch('changDic', res.data)
    })
  }
}
</script>

<style>
#app {
  font-family: "Microsoft YaHei Bold", "Microsoft YaHei Regular", "Microsoft YaHei";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
  padding: 0;
  margin: 0;
  height:100%;
  overflow: hidden;
  min-width: 1200px;
  background-color:#f9f9f9;
}
</style>



// WEBPACK FOOTER //
// src/App.vue